export default class PlatformDocumentMetadata {
    id: string | null = null;
    name: string = "";
    contentType: string = "";
    documentArchiveID: string | null = null;
    dateCreatedUTC: Date = new Date();
}
